export default function initProductSearch() {
  document.querySelectorAll('[data-product-search]').forEach(function (form) {
    var input = form.querySelector('[data-product-search-input]');
    var panel = form.querySelector('[data-search-panel]');
    var results = form.querySelector('[data-search-results]');
    var message = form.querySelector('[data-search-message]');
    var status = form.querySelector('[data-search-status]');
    var endpoint = form.getAttribute('data-search-endpoint');
    var copy = {
      notFound: form.getAttribute('data-search-not-found'),
      noneAvailable: form.getAttribute('data-search-none-available'),
      oneAvailable: form.getAttribute('data-search-one-available'),
      manyAvailable: form.getAttribute('data-search-many-available'),
      searching: form.getAttribute('data-search-searching'),
      searchingStatus: form.getAttribute('data-search-searching-status'),
      loadError: form.getAttribute('data-search-load-error'),
      loadErrorStatus: form.getAttribute('data-search-load-error-status'),
      minimum: form.getAttribute('data-search-minimum'),
      closed: form.getAttribute('data-search-closed')
    };
    var debounceTimer = null;
    var requestController = null;
    var activeIndex = -1;
    var cache = {};

    if (!input || !panel || !results || !message || !status || !endpoint) {
      return;
    }

    function options() {
      return Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
    }

    function announce(text) {
      status.textContent = '';
      window.setTimeout(function () {
        status.textContent = text;
      }, 20);
    }

    function clearResults() {
      while (results.firstChild) {
        results.removeChild(results.firstChild);
      }
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
    }

    function closePanel() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      clearResults();
      message.hidden = true;
    }

    function cancelPendingSearch() {
      window.clearTimeout(debounceTimer);
      form.classList.remove('is-loading');

      if (requestController) {
        requestController.abort();
        requestController = null;
      }
    }

    function showMessage(text) {
      clearResults();
      message.textContent = text;
      message.hidden = false;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'false');
    }

    function setActiveOption(nextIndex) {
      var availableOptions = options();

      if (!availableOptions.length) {
        return;
      }

      activeIndex = (nextIndex + availableOptions.length) % availableOptions.length;

      availableOptions.forEach(function (option, index) {
        var isActive = index === activeIndex;
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      input.setAttribute('aria-activedescendant', availableOptions[activeIndex].id);
      availableOptions[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    function createText(className, text) {
      var element = document.createElement('span');
      element.className = className;
      element.textContent = text;
      return element;
    }

    function createHtml(className, html) {
      var element = document.createElement('span');
      element.className = className;
      element.innerHTML = html;
      return element;
    }

    function renderProducts(products, query) {
      clearResults();
      form.classList.remove('is-loading');

      if (!products.length) {
        showMessage(copy.notFound.replace('%query%', query));
        announce(copy.noneAvailable);
        return;
      }

      message.hidden = true;

      products.forEach(function (product, index) {
        var option = document.createElement('a');
        var image = document.createElement('img');
        var content = document.createElement('span');

        option.className = 'c-search__option';
        option.id = input.id + '-option-' + index;
        option.href = product.url;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.setAttribute('tabindex', '-1');

        image.className = 'c-search__image';
        image.src = product.image;
        image.alt = '';
        image.width = 58;
        image.height = 58;
        image.loading = 'lazy';

        content.className = 'c-search__content';
        if (product.category) {
          content.appendChild(createText('c-search__category', product.category));
        }
        content.appendChild(createText('c-search__name', product.name));

        option.appendChild(image);
        option.appendChild(content);
        if (product.price_html) {
          option.appendChild(createHtml('c-search__price', product.price_html));
        } else if (product.price) {
          option.appendChild(createText('c-search__price', product.price));
        }

        option.addEventListener('mouseenter', function () {
          setActiveOption(index);
        });

        results.appendChild(option);
      });

      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      announce((products.length === 1 ? copy.oneAvailable : copy.manyAvailable)
        .replace('%count%', products.length));
    }

    function fetchProducts(query) {
      var cacheKey = query.toLocaleLowerCase();

      if (cache[cacheKey]) {
        renderProducts(cache[cacheKey], query);
        return;
      }

      if (requestController) {
        requestController.abort();
      }

      requestController = typeof AbortController !== 'undefined' ? new AbortController() : null;
      form.classList.add('is-loading');
      showMessage(copy.searching);
      announce(copy.searchingStatus);

      var url = new URL(endpoint, window.location.href);
      url.searchParams.set('search', query);
      var fetchOptions = {
        headers: { Accept: 'application/json' }
      };

      if (requestController) {
        fetchOptions.signal = requestController.signal;
      }

      window.fetch(url.toString(), fetchOptions)
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Search request failed');
          }
          return response.json();
        })
        .then(function (products) {
          if (input.value.trim() !== query) {
            return;
          }

          cache[cacheKey] = Array.isArray(products) ? products : [];
          renderProducts(cache[cacheKey], query);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') {
            return;
          }

          form.classList.remove('is-loading');
          showMessage(copy.loadError);
          announce(copy.loadErrorStatus);
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();

      window.clearTimeout(debounceTimer);
      form.classList.remove('is-loading');

      if (requestController) {
        requestController.abort();
      }

      if (query.length < 2) {
        closePanel();
        if (query.length === 1) {
          announce(copy.minimum);
        }
        return;
      }

      closePanel();
      debounceTimer = window.setTimeout(function () {
        fetchProducts(query);
      }, 260);
    });

    input.addEventListener('keydown', function (event) {
      var availableOptions = options();

      if (event.key === 'ArrowDown' && availableOptions.length) {
        event.preventDefault();
        setActiveOption(activeIndex + 1);
      } else if (event.key === 'ArrowUp' && availableOptions.length) {
        event.preventDefault();
        setActiveOption(activeIndex <= 0 ? availableOptions.length - 1 : activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0 && availableOptions[activeIndex]) {
        event.preventDefault();
        window.location.assign(availableOptions[activeIndex].href);
      } else if (event.key === 'Escape' && !panel.hidden) {
        event.preventDefault();
        event.stopPropagation();
        cancelPendingSearch();
        closePanel();
        announce(copy.closed);
      }
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) {
        cancelPendingSearch();
        closePanel();
      }
    });

    document.addEventListener('crispins:search-drawer-closed', function () {
      cancelPendingSearch();
      closePanel();
    });
  });
}
